import user from "./modules/user";
import guild from "./modules/guild";
import common from "./modules/common";
import agent from "./modules/agent";
import pay from "./modules/pay";
import withdraw from "./modules/withdraw";
import family from "./modules/family";

export default {
  user,
  guild,
  common,
  agent,
  pay,
  withdraw,
  family
}